import Auth from './Auth';
import User from './User';
import Theme from './Theme';
import Loading from './Loading';
import UserRoles from './UserRoles';
import Notifications from './Notifications';
import Powerbox from './Powerbox';
import Organizations from './Organizations';
import Blacklist from './Blacklist';
import Member from './Member';
import License from './License';
import EMSUsageReports from './EMSUsageReports';
import AppLogs from './AppLogs';

const config = {
  Auth,
  User,
  Theme,
  Loading,
  UserRoles,
  Notifications,
  Powerbox,
  Organizations,
  Member,
  License,
  Blacklist,
  EMSUsageReports,
  AppLogs,
};

export default config;
